export default "__VITE_ASSET__BQGDy5K9__"